module.exports = __webpack_public_path__ + "img/success_tick.68ddb893.svg";